<template>
  <v-main>
    <BaseCrudTable ref="basetable"
                   :headers="headers"
                   table-name="Пользователи"
                   endpoint="users"
                   label="Место"
                   @editClicked="editClick">
      <template v-slot:editVals>
        <v-col>
          <div ref="form">
            <v-card-text>
              <v-text-field
                ref="email"
                v-model.trim="editItem.email"
                :rules="[() => !!editItem.email || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Почта"
                placeholder="Введите почту"
                required />
            </v-card-text>
            <v-card-text>
              <v-text-field
                ref="name"
                v-model.trim="editItem.name"
                :rules="[() => !!editItem.name || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Имя"
                placeholder="Введите имя"
                required />
            </v-card-text>
            <v-card-text>
              <v-text-field
                ref="surname"
                v-model.trim="editItem.surname"
                :rules="[() => !!editItem.surname || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Фамилия"
                placeholder="Введите фамилию"
                required />
            </v-card-text>
            <v-card-text>
              <BaseAutoComplete ref="user_roles"
                                v-model="editItem.user_roles"
                                :items="roles"
                                :rules="[() => !!editItem.user_roles || 'Поле обязательно']"
                                :value="rolesSelected"
                                :error-messages="errorMessages"
                                label="Роли"
                                required
                                @updateSelected="updateRoles" />
            </v-card-text>

            <v-card-text>
              <v-select
                ref="type"
                v-model="editItem.type"
                :items="['админ','пользователь', 'волонтер']"
                :rules="[() => !!editItem.type || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Тип пользователя"
                required />
            </v-card-text>

            <v-card-text>
              <v-text-field
                ref="password"
                v-model.trim="editItem.password"
                label="Пароль"
                placeholder="Введите пароль"
                required />
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="close()">
                Отмена
              </v-btn>
              <v-spacer />
              <v-slide-x-reverse-transition>
                <v-tooltip
                  v-if="formHasErrors"
                  left />
              </v-slide-x-reverse-transition>
              <v-btn color="primary" text @click="submit">
                Подтвердить
              </v-btn>
            </v-card-actions>
          </div>
        </v-col>
      </template>
    </BaseCrudTable>
  </v-main>
</template>

<script>
import BaseCrudTable from '../base/BaseCrudTable'
import BaseAutoComplete from '../base/BaseAutoComplete'
import {mapState} from 'vuex'

export default {
  name: "UsersTable",
  components: {BaseCrudTable,
              BaseAutoComplete,
},
  data () {
    return {
      headers: [
        {text: '', value: '', align: 'left'},
        {text: 'id', value: 'id', align: 'left', class:['d-none']},
        {
          text: 'Почта',
          align: 'left',
          value: 'email'
        },
        {text: 'Имя', value: 'name', align: 'left'},
        {text: 'Фамилия', value: 'surname', align: 'left'},
        {text: 'Полное', value: 'full_name', align: 'left'},
        {text: 'Роль', value: 'user_roles', align: 'left'},
        {text: 'Тип', value: 'type', align: 'left'},
        {text: 'Действия', value: 'role', sortable: false, align: 'center'}
      ],
      editItem: {
        name: '',
        email: '',
        surname: '',
        password: '',
        id: '',
        user_roles: {'id':'','value':''},
        type: ''
      },
      dialog: false,
      errorMessages: '',
      formHasErrors: false,
      rolesSelected: []
    }
  },
  computed: {
    form () {
      return {
        name: this.editItem.name,
        email: this.editItem.email,
        surname: this.editItem.surname,
        password: this.editItem.password,
        user_roles: this.editItem.user_roles,
        type: this.editItem.type
      }
    },
    ...mapState({
      roles: state => state.tableData.roles
  })
  },
  methods: {
    editClick (newVal) {
      this.rolesSelected = newVal['user_roles'].map(val => { return val.id })
      this.simpleEditClick(newVal)

    },
    submit () {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (f!=='password' && f!=='user_roles')  {
          if (!this.form[f]) this.formHasErrors = true
           this.$refs[f].validate(true)
          }
      })
       if (!this.formHasErrors) {
         this.$refs["basetable"].save(this.editItem)
       }
      this.$store.dispatch("tableData/loadUsers")

    },
    close () {
      this.$refs["basetable"].close()
    },
    updateRoles (newVal) {
      this.rolesSelected = newVal
      this.editItem.user_roles = newVal
    },
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/UsersTable.vue